import { useQuery } from "@tanstack/react-query";
import { getReportSchedules } from "../services/report-schedule-service";
import { NotificationSchedule } from "../types";

export const REPORT_SCHEDULES_QUERY_KEY = "report-schedules";

/**
 * A empresa é resolvida pelo backend a partir do JWT, então não há
 * `companyId` na key nem na query — basta estar autenticado.
 */
export function useReportSchedules() {
  const query = useQuery<NotificationSchedule[]>({
    queryKey: [REPORT_SCHEDULES_QUERY_KEY],
    queryFn: ({ signal }) => getReportSchedules({}, signal),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  return {
    schedules: query.data ?? [],
    isLoading: query.isLoading,
  };
}
